// ANCHOR React
import { useCallback } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';
import { LabelLarge } from 'baseui/typography';
import { styled } from 'baseui';

// ANCHOR Model
import { ConfirmationModalVisibility } from '@lyon/scoped-models/confirmation-modal/ConfirmationModalVisibility';
import { useFormQuestionItemDataID, useFormQuestionItemDataName, useFormQuestionItemDataPosition } from '@lyon/scoped-models/form/FormQuestionItemData';
import { useFormDataShuffleQuestion } from '@lyon/scoped-models/form/FormData';
import { useFormQuestionActiveDispatch } from '@lyon/scoped-models/form/FormQuestionActive';
import { UpdateFormQuestionPositionModalVisibility } from '@lyon/scoped-models/form/update/UpdateFormQuestionPositionModalVisibility';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { BoxSkeleton } from '@lyon/components/utils/BoxSkeleton';
import { LyonUpdateFormOutlineTabListItemButton } from './LyonUpdateFormOutlineTabListItemButton';

// ANCHOR Styles
import { NAME, BLOCK, DIV } from './styles';

const ClickableDiv = styled('div', DIV);

export const LyonUpdateFormOutlineTabListItem = constant(() => {
  const questionId = useFormQuestionItemDataID();
  const title = useFormQuestionItemDataName();
  const position = useFormQuestionItemDataPosition();
  const shuffleQuestion = useFormDataShuffleQuestion();
  const setActive = useFormQuestionActiveDispatch();

  const onClick = useCallback(() => {
    setActive(questionId);
  }, [questionId, setActive]);

  if (title && position) {
    const NUMBER = (position >= 0 && position < 10) ? `0${position}` : position;
    const LABEL = `${shuffleQuestion ? '' : `${NUMBER}: `}${title}`;

    return (
      <Block overrides={BLOCK}>
        <ClickableDiv
          onClick={onClick}
          role="button"
          tabIndex={0}
        >
          <LabelLarge overrides={NAME}>
            {LABEL}
          </LabelLarge>
        </ClickableDiv>
        <ConfirmationModalVisibility.Provider>
          <UpdateFormQuestionPositionModalVisibility.Provider>
            <LyonUpdateFormOutlineTabListItemButton />
          </UpdateFormQuestionPositionModalVisibility.Provider>
        </ConfirmationModalVisibility.Provider>
      </Block>
    );
  }

  return (
    <BoxSkeleton
      height="16px"
      width="100%"
      animation
      rows={1}
      rowSpacing="8px"
    />
  );
});
